$(document).ready(function(){

    var hrs = 3;
    var timeCompare = moment().add(hrs, 'h').format('YYYY-MM-DD HH:mm');

    $(".cerrar").click(function () {
        localStorage.setItem('modalMVC', timeCompare);
        $("#ad").modal('hide');
    });

    var isActive = moment(localStorage.getItem('modalMVC'));
    var realtime =  moment().format('YYYY-MM-DD HH:mm');

    if(isActive.isValid()){
        if (isActive == "" || isActive != null || isActive != undefined){
            if( moment(isActive).isSame(realtime) || moment(realtime).isAfter(isActive, 'h')) {
                localStorage.removeItem('modalMVC');
                setTimeout(function () {
                    $("#ad").modal('show');
                },2000);
            }
        }else{
            setTimeout(function () {
                $("#ad").modal('show');
            },2000);
        }
    }else{
        setTimeout(function () {
            $("#ad").modal('show');
        },2000);
    }

});


    $('body').on('click', '.btn_payment', function() {
	if(validate_form()){
		$('#loaderStylereservando').css('display', 'block');
		$('#loader').css('display', 'block');
		$("#cargandoSubmitFormParametros").show();
		$("#cargandoSubmitFormParametros .csfp_titulo").html('<i class="fa fa-3x fa-cog fa-spin"></i>');		
		$("#form-datos-pago-res").submit();
	}
	else {
		if( $("#tarjeta_credito").val() == ""){
			$('span[data-message="'+$("#tarjeta_credito").attr('data-input')+'"]').removeClass('d-none');
			$("#tarjeta_credito").css("border", "solid 1px red");	
		}
		if( $("#nombre_tarjeta").val() == ""){
			$('span[data-message="'+$("#nombre_tarjeta").attr('data-input')+'"]').removeClass('d-none');
			$("#nombre_tarjeta").css("border", "solid 1px red");	
		}
		if( $("#expiry").val() == ""){
			$('span[data-message="'+$("#expiry").attr('data-input')+'"]').removeClass('d-none');
			$("#expiry").css("border", "solid 1px red");	
		}
		if( $("#cvc").val() == ""){
			$('span[data-message="'+$("#cvc").attr('data-input')+'"]').removeClass('d-none');
			$("#cvc").css("border", "solid 1px red");	
		}
	}
});
/*$(window).load(function(){
});*/
	if($("#errorPago").length)
		$('#modalError').modal('show');

//$(document).ready(function() {	

	$(".rf").click(function(){return false;});

	$(function () {
		$('[data-toggle="popover"]').popover()
	})
	$('body').on('click', function (e) {
	    $('[data-toggle="popover"]').each(function () {
	        //the 'is' for buttons that trigger popups
	        //the 'has' for icons within a button that triggers a popup
	        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
	            $(this).popover('hide');
	        }
	    });
	});

	// Se pasa a una directive
	/*$('#cont_tarjeta_credito').card({
	    // a selector or DOM element for the container
	    // where you want the card to appear
	    container: '#card-container', // *required*
	    width: 200,

	    // all of the other options from above
	});*/

	// $('body').on('blur', '#tarjeta_credito', function(event) {
		
	// 	$('#tipo_tarjeta').val("");
	// 	var arTarjetas = ['jp-card-mastercard', 'jp-card-maestro', 'jp-card-amex', 'jp-card-discover', 'jp-card-dankort', 'jp-card-visa'];
	// 	var tipo = "";
		
	// 	for (var i = 0; i < arTarjetas.length; i++) {
	// 		//console.log('entré a for');
	// 		if($(".jp-card").hasClass(arTarjetas[i])){
	// 			//console.log(arTarjetas[i]);
	// 			tipo = arTarjetas[i];
	// 			break;
	// 		}
	// 	};
		
	// 	if ($.inArray(tipo, ['jp-card-mastercard', 'jp-card-visa', 'jp-card-discover', 'jp-card-maestro', 'jp-card-dankort']) > -1){
	// 		$('#tipo_tarjeta').val("banamex");
	// 	}
	// 	else if($.inArray(tipo, ['jp-card-amex']) > -1){
	// 		$('#tipo_tarjeta').val("amex");
	// 	}

	// });

	function indentifyCardType(card_number){
		card_number = String(card_number);
	
		let cards = [
			{
				regex: "^3[47]",
				type: "amex",
				icon: "fab fa-cc-amex fa-3x card-amex"
			},
			{
				regex: "^(6541|6556)[0-9]{12}",
				type: "bcglobal",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^389[0-9]{11}",
				type: "carte blanche",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^5019",
				type: "dankort",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^(36|38|30[0-5])",
				type: "dinersclub",
				icon: "fab fa-cc-dinersclub fa-3x card-dinners"
			},
			{
				regex: "^(6011|65|64[4-9]|622)",
				type: "discover",
				icon: "fab fa-cc-discover fa-3x card-discover"
			},
			{
				regex: "^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))",
				type: "elo",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^35",
				type: "jcb",
				icon: "fab fa-cc-jcb fa-3x card-jcb"
			},
			{
				regex: "^(6304|6706|6709|6771)[0-9]{12,15}",
				type: "laser",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^(5018|5020|5038|5893|6304|6703|6708|6759|6799|676[1-3])",
				type: "maestro",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d2}|27[0-1]\d|2720)",
				type: "mastercard",
				icon: "fab fa-cc-mastercard fa-3x card-mastercard"
			},
			{
				regex: "^62",
				type: "unionpay",
				icon: "fas fa-credit-card fa-3x"
			},
			{
				regex: "^4(026|17500|405|508|844|91[37])",
				type: "visa electron",
				icon: "fab fa-cc-visa fa-3x card-visa"
			},
			{
				regex: "^4",
				type: "visa",
				icon: "fab fa-cc-visa fa-3x card-visa"
			}
		];
	
		for (card of cards) {
			if (card_number.match(card.regex) != null){
				let card_data = {
					"type": card.type,
					"icon": card.icon
				};
				return card_data;
			}
		}
	
		return {
			"type":"",
			"icon":"fas fa-credit-card fa-3x"
		};;
	}
	
	$('body').on('keyup', '#tarjeta_credito', function(){
		let cc_type = indentifyCardType($(this).val());
		$('#cc_icon').attr('class', cc_type.icon);
		if(cc_type.type != ""){
			if(
				cc_type.type == "visa" || 
				cc_type.type == "discover" || 
				cc_type.type == "mastercard"
			){
				$('input[name="tipo_tarjeta"]').val('banamex');
	
			}
			else{
				$('input[name="tipo_tarjeta"]').val('amex');
			}
		}
	});
	
	$('body').on('focus', '#tarjeta_credito', function(){
		let type = $('#tipo_tarjeta').val();
		console.log()
		if(type === ''){
			let cc_type = indentifyCardType($(this).val());
			$('#cc_icon').attr('class', cc_type.icon);
			if(cc_type.type != ""){
				if(
					cc_type.type == "visa" || 
					cc_type.type == "discover" || 
					cc_type.type == "mastercard"
				){
					type = 'banamex';
					$('input[name="tipo_tarjeta"]').val(type);
				}
				else {
					type = 'amex';
					$('input[name="tipo_tarjeta"]').val(type);
				}				
				
				$(this).val(cc_format($(this).val(), type));
			}
		}
		else {
			$(this).val(cc_format($(this).val(), type));
		}
	});
	function cc_format(value, type) {
		let new_value = '';
		if (type === 'amex') {
			new_value = value.replace(/\b(\d{4})(\d{6})(\d{5})\b/, '$1 $2 $3');
			return new_value;
		} else {
			new_value = value.replace(/\b(\d{4})(\d{4})(\d{4})(\d{4})\b/, '$1 $2 $3 $4');
			return new_value;
		}
	}

	function validate_form () {
		$("#error_cc").css("display", "none");
		if( $("#tarjeta_credito").val() == "" || $("#nombre_tarjeta").val() == "" || $("#expiry").val() == "" || $("#cvc").val() == ""){
			return false;
		}
		return true;		
	}

	$('body').on('submit', '#pago-form-data', function () {
			$("#error_cc").css("display", "none");
			if( $("#tarjeta_credito").val() == "" || $("#nombre_tarjeta").val() == "" || $("#expiry").val() == "" || $("#cvc").val() == "" || $("#Modopago").val() == "" || $("#Monto").val()== "" || $("#Moneda").val()==""){
				
				if( $("#tarjeta_credito").val() == ""){
					$("#tarjeta_credito").css("border", "solid 1px red");	
				}else{
					$("#tarjeta_credito").css("border", "solid 1px #ccc");	
				}
				if( $("#nombre_tarjeta").val() == ""){
					$("#nombre_tarjeta").css("border", "solid 1px red");	
				}else{
					$("#nombre_tarjeta").css("border", "solid 1px #ccc");	
				}
				if( $("#expiry").val() == ""){
					$("#expiry").css("border", "solid 1px red");	
				}else{
					$("#expiry").css("border", "solid 1px #ccc");	
				}
				if( $("#cvc").val() == ""){
					$("#cvc").css("border", "solid 1px red");	
				}else{
					$("#cvc").css("border", "solid 1px #ccc");	
				}
				if( $("#ModoPago").val() == ""){
					$("#ModoPago").css("border", "solid 1px red");	
				}else{
					$("#ModoPago").css("border", "solid 1px #ccc");	
				}
				if( $("#Monto").val() == ""){
					$("#Monto").css("border", "solid 1px red");	
				}else{
					$("#Monto").css("border", "solid 1px #ccc");	
				}
				if( $("#Moneda").val() == ""){
					$("#Moneda").css("border", "solid 1px red");	
				}else{
					$("#Moneda").css("border", "solid 1px #ccc");	
				}
				$("#error_cc").css("display", "block");
				
				return false;
			}
			
			$(".btnPagar").removeClass("disabled");
			
			return true;
		
		
	});
	


	$( document ).on( "keydown", "#tarjeta_credito", function() {
		$('span[data-message="'+$("#tarjeta_credito").attr('data-input')+'"]').addClass('d-none');
		$("#tarjeta_credito").css("border", "1px solid #CCC");
		if(validate_form()) { $(".btn_payment").removeClass("disabled");}
		else { $(".btn_payment").addClass("disabled");}
	});

	$( document ).on( "keydown", "#nombre_tarjeta", function() {
		$('span[data-message="'+$("#nombre_tarjeta").attr('data-input')+'"]').addClass('d-none');
		$("#nombre_tarjeta").css("border", "1px solid #CCC");
		if(validate_form()) { $(".btn_payment").removeClass("disabled");}
		else { $(".btn_payment").addClass("disabled");}
	});

	$( document ).on( "keydown", "#expiry", function() {
		$('span[data-message="'+$("#expiry").attr('data-input')+'"]').addClass('d-none');
		$("#expiry").css("border", "1px solid #CCC");
		if(validate_form()) { $(".btn_payment").removeClass("disabled");}
		else { $(".btn_payment").addClass("disabled");}
	});

	$( document ).on( "keydown", "#cvc", function() {
		$('span[data-message="'+$("#cvc").attr('data-input')+'"]').addClass('d-none');
		$("#cvc").css("border", "1px solid #CCC");
		if(validate_form()) { $(".btn_payment").removeClass("disabled");}
		else { $(".btn_payment").addClass("disabled");}
	});	

		function Vermas(){

		document.getElementById("descripcorta").style.display = "none";
		document.getElementById("descriplarga").style.display = "block";
		document.getElementById("vermas").style.display = "none";
		document.getElementById("vermenos").style.display = "block";

		}


		function Vermenos(){

			document.getElementById("descripcorta").style.display = "block";
			document.getElementById("descriplarga").style.display = "none";
			document.getElementById("vermas").style.display = "block";
			document.getElementById("vermenos").style.display = "none";

		}


		//seccion de popover para imprimir voucher desde el menú

		$( document ).on( "click", ".btnBuscarclv", function() {
			var clv_interna = $('#clave_res').val();
			var correo_res = $('#correo_res').val();
			
			var _token = $('#_token').val();

			$.ajax({
			type: "post",
			url:  "/validaVoucher",
			data: {clv_interna: clv_interna,correo_res: correo_res, _token: _token},
			success: function(data){
				data = JSON.parse(data);
				
				if (clv_interna == "") {
					return $('.msj_error_buscar').html('<div class="alert alert-danger" role="alert"><strong>El campo esta vacio</strong>, se requiere una clave valida.</div>');
				}

				if (correo_res == "") {
					return $('.msj_error_buscar').html('<div class="alert alert-danger" role="alert"><strong>El campo correo esta vacio</strong>, se requiere una correo valido.</div>');
				}

				if (data == false) {
					return $('.msj_error_buscar').html('<div class="alert alert-danger" role="alert"><strong>La reservación o el correo</strong>, no son validos verifique sus datos.</div>');
				}

				if (data.estado == 'nvo') {
					return $('.msj_error_buscar').html('<div class="alert alert-info" role="alert"><strong>La reservación</strong>, esta en proceso.</div>');
				}

				if (data.estado == 'cld') {
					return $('.msj_error_buscar').html('<div class="alert alert-info" role="alert"><strong>La reservación</strong>, esta cancelada.</div>');
				}

				if (data.estado == 'tpo' || data.estado == 'ppo' || data.estado == 'fdd'){
					
					return window.location.replace("/voucher/"+clv_interna+"");
				}
				

			},
			error: function(data){
				console.log('error');	
			} 
		});

	});

	 function des(){
		 document.getElementById('but').disabled = true;
	 }

	  function valida(e){
		tecla = (document.all) ? e.keyCode : e.which;
		if (tecla==8){
			return true;
		}
		patron =/[0-9]/;
		tecla_final = String.fromCharCode(tecla);
		return patron.test(tecla_final);
	  }
